<style lang="scss" scoped>
.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;

  h1.title {
    font-size: 72pt;
  }

  p.description {
    font-size: 14pt;
  }

  .divider {
    margin: 3em;
  }

  .actions {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;

    span {
      margin-right: .5em;
    }

    .google {
      background-color: #d34836;
      border-radius: .25em;
      color: #fff;
      font-size: 14pt;
      font-weight: 900;
      margin-left: .5em;
      padding: .5em 1.5em;

      &:hover {
        background-color: #a01503;
        text-decoration: none;
      }
    }
  }

  p.footnote {
    font-size: 8pt;
    margin-top: 1em;
  }
}
</style>

<template>
  <div class="container">
    <h1 class="title">Teary</h1>
    <p class="description">
      An online auto grader for Logic Programming course
    </p>
    <div class="divider"/>
    <div class="actions">
      <span>Login with</span>
      <router-link to="/login" class="google">Google</router-link>
    </div>
    <p class="footnote">
      *please login with your lecturer/student email from Telkom University
    </p>
  </div>
</template>

<script>
import { redirectIfLoggedIn } from '@/helpers/loginChecker';

export default {
  name: 'home',
  watch: {
    $route: {
      immediate: true,
      async handler() {
        await redirectIfLoggedIn(this);
      },
    },
  },
};
</script>
